import React, { useState } from 'react';

/**
 * Compact daily challenge indicator that expands on click
 */
const DailyChallenge = ({ challengeInfo, isDarkMode }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!challengeInfo) {
    return null;
  }

  const { icon, name, description, xpReward, progress, target, percent, isCompleted } = challengeInfo;

  // Compact view (default)
  if (!isExpanded) {
    return (
      <button
        onClick={() => setIsExpanded(true)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '6px 12px',
          backgroundColor: isDarkMode ? '#1e293b' : '#ffffff',
          border: `1px solid ${isCompleted ? '#22c55e' : (isDarkMode ? '#334155' : '#e2e8f0')}`,
          borderRadius: '10px',
          cursor: 'pointer',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          transition: 'all 0.2s ease',
          fontSize: '12px',
          color: isDarkMode ? '#f1f5f9' : '#1e293b'
        }}
        title={`${name}: ${description}`}
      >
        <span>{icon}</span>
        <div style={{
          width: '40px',
          height: '4px',
          backgroundColor: isDarkMode ? '#334155' : '#e2e8f0',
          borderRadius: '2px',
          overflow: 'hidden'
        }}>
          <div style={{
            width: `${percent}%`,
            height: '100%',
            backgroundColor: isCompleted ? '#22c55e' : '#3b82f6',
            borderRadius: '2px'
          }} />
        </div>
        {isCompleted ? (
          <span style={{ color: '#22c55e', fontWeight: 600 }}>Done!</span>
        ) : (
          <span style={{ opacity: 0.7 }}>{progress}/{target}</span>
        )}
        <span style={{ opacity: 0.5 }}>▼</span>
      </button>
    );
  }

  // Expanded view
  return (
    <div
      style={{
        backgroundColor: isDarkMode ? '#1e293b' : '#ffffff',
        border: `2px solid ${isCompleted ? '#22c55e' : (isDarkMode ? '#334155' : '#e2e8f0')}`,
        borderRadius: '8px',
        padding: '12px',
        boxShadow: isCompleted
          ? '0 0 20px rgba(34, 197, 94, 0.3)'
          : '0 2px 8px rgba(0,0,0,0.1)',
        transition: 'all 0.3s ease',
        maxWidth: '320px'
      }}
    >
      {/* Header with close button */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <span style={{ fontSize: '20px', marginRight: '8px' }}>{icon}</span>
        <div style={{ flex: 1 }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <h4 style={{
              margin: 0,
              fontSize: '14px',
              fontWeight: 600,
              color: isDarkMode ? '#f1f5f9' : '#1e293b'
            }}>
              {name}
              {isCompleted && <span style={{ marginLeft: '6px', color: '#22c55e', fontSize: '12px' }}>Done!</span>}
            </h4>
            <button
              onClick={() => setIsExpanded(false)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '2px 6px',
                fontSize: '14px',
                color: isDarkMode ? '#94a3b8' : '#64748b',
                opacity: 0.7
              }}
              title="Collapse"
            >
              ▲
            </button>
          </div>
        </div>
      </div>

      <p style={{
        margin: '0 0 8px 0',
        fontSize: '12px',
        color: isDarkMode ? '#94a3b8' : '#64748b'
      }}>
        {description}
      </p>

      {/* Progress bar */}
      <div style={{
        backgroundColor: isDarkMode ? '#334155' : '#e2e8f0',
        borderRadius: '4px',
        height: '6px',
        overflow: 'hidden',
        marginBottom: '6px'
      }}>
        <div style={{
          width: `${percent}%`,
          height: '100%',
          backgroundColor: isCompleted ? '#22c55e' : '#3b82f6',
          borderRadius: '4px',
          transition: 'width 0.3s ease'
        }} />
      </div>

      {/* Footer with progress and XP */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '11px'
      }}>
        <span style={{ color: isDarkMode ? '#94a3b8' : '#64748b' }}>
          {progress} / {target}
        </span>
        <span style={{
          backgroundColor: isCompleted ? '#22c55e' : (isDarkMode ? '#3b82f6' : '#2563eb'),
          color: '#ffffff',
          padding: '2px 8px',
          borderRadius: '6px',
          fontWeight: 600
        }}>
          +{xpReward} XP
        </span>
      </div>
    </div>
  );
};

export default DailyChallenge;
